import React from 'react'

import { DoubleColContainer, FieldRow, Form } from './style'
import { PlainCard } from '../..'
import { useChallenge } from '../../../context'
import { DynamicField } from '../../DynamicFields/DynamicField'
import FormField from '../../FormField'

const ChallengeForm = () => {
  const { formActions, formState } = useChallenge()
  const { fields, ...actions } = formActions

  return (
    <Form>
      {fields.map((field) => (
        <PlainCard
          key={field.title}
          title={field.title}
          className={field.className}
        >
          <FieldRow style={{ display: 'flex' }}>
            {field.rowRight && (
              <FieldRow>
                {field.rowRight.map((item, index) => {
                  const nextItem = field.rowRight && field.rowRight[index + 1]
                  const extraClass =
                    item.id === 'instructions' ? 'push-to-bottom' : undefined

                  if (item.id === 'startDate') {
                    return (
                      <DoubleColContainer key={`dates-${item.id}`}>
                        <FormField id={item.id} label={item.label}>
                          <DynamicField
                            item={item}
                            stateFn={actions}
                            refId={formState.id}
                          />
                        </FormField>

                        {nextItem?.id === 'endDate' && (
                          <FormField id={nextItem.id} label={nextItem.label}>
                            <DynamicField
                              item={nextItem}
                              stateFn={actions}
                              refId={formState.id}
                            />
                          </FormField>
                        )}
                      </DoubleColContainer>
                    )
                  }

                  if (item.id === 'category') {
                    return (
                      <DoubleColContainer key={`states-${item.id}`}>
                        <FormField
                          id={item.id}
                          label={item.label}
                          className="col-md"
                        >
                          <DynamicField
                            item={item}
                            stateFn={actions}
                            refId={formState.id}
                          />
                        </FormField>

                        {nextItem?.id === 'status' && (
                          <FormField
                            id={nextItem.id}
                            label={nextItem.label}
                            className="col-md"
                          >
                            <DynamicField
                              item={nextItem}
                              stateFn={actions}
                              refId={formState.id}
                            />
                          </FormField>
                        )}
                      </DoubleColContainer>
                    )
                  }

                  // Si es endDate, ya lo renderizamos arriba → no lo repetimos
                  if (item.id === 'endDate' || item.id === 'status') return null

                  // Render normal para todos los demás campos
                  return (
                    <FormField
                      id={item.id}
                      label={item.label}
                      key={item.id}
                      className={extraClass}
                    >
                      <DynamicField
                        item={item}
                        stateFn={actions}
                        refId={formState.id}
                      />
                    </FormField>
                  )
                })}
              </FieldRow>
            )}

            {field.rowLeft && (
              <FieldRow>
                {field.rowLeft.map((item) => (
                  <FormField id={item.id} label={item.label} key={item.id}>
                    <DynamicField
                      item={item}
                      stateFn={actions}
                      refId={formState.id}
                    />
                  </FormField>
                ))}
              </FieldRow>
            )}
          </FieldRow>
        </PlainCard>
      ))}
    </Form>
  )
}

export default ChallengeForm
